export const AdminRouteName = {
  // LOGIN
  loginRoute: '/',
  // DASHBOARD
  dashboardRoute: '/dashboard',
  // CUSTOMERS
  customersBaseRoute: '/customers',
  customersRoute: '/customers/overview',
  activeCustomersRoute: '/customers/overview/active-customers',
  inactiveCustomersRoute: '/customers/overview/inactive-customers',
  awaitingApprovedCustomersRoute:
    '/customers/overview/awaiting-approved-customers',
  prospectiveCustomersRoute: '/customers/overview/prospective-customers',
  deleteCustomersRoute: '/customers/overview/delete-customers',
  declineCustomersRoute: '/customers/overview/declined-customers',
  priorityCustomersRoute: '/customers/overview/priority-customers',
  customerDetailsRoute: '/customers/customer-details/:customerId',
  customerDetailsProfileEditRoute:
    '/customers/customer-details/:customerId/student-details',
  customerResidentialDetailEditRoute:
    '/customers/customer-details/:customerId/residential-details',
  customerInstututionDetailEditRoute:
    '/customers/customer-details/:customerId/institution-details',
  customerApprovedVerficationEditRoute:
    '/customers/customer-details/:customerId/approved-details',
  customerDetailsProfileRoute:
    '/customers/customer-details/:customerId/profile',
  customerDetailsVerificationRoute:
    '/customers/customer-details/:customerId/verification',
  customerDetailsDocumentsRoute:
    '/customers/customer-details/:customerId/documents',
  customerDetailsTransactionsRoute:
    '/customers/customer-details/:customerId/transactions',
  customerDetailsLoanRoute:
    '/customers/customer-details/:customerId/loan/credits',
  customerDetailsLoanGuaranteeRoute:
    '/customers/customer-details/:customerId/loan/guarantee',
  customerDetailsRepaymentRoute:
    '/customers/customer-details/:customerId/repayment',
  customerDetailsWalletRoute: '/customers/customer-details/:customerId/wallet',
  customerDetailsCommentRoute:
    '/customers/customer-details/:customerId/comments',
  customerDetailsNotificationsRoute:
    '/customers/customer-details/:customerId/notifications',
  customerDetailsSDKActivitiesRoute:
    '/customers/customer-details/:customerId/sdk-activities',
  customerDetailsTransactionBnplRoute:
    '/customers/customer-details/:customerId/transactions',
  customerDetailsTransactionWalletRoute:
    '/customers/customer-details/:customerId/transactions/wallet',
  customerDetailsRewardHistoryRoute:
    '/customers/customer-details/:customerId/reward-history',
  customerDetailsEarningsRoute:
    '/customers/customer-details/:customerId/reward-history/earnings',
  customerDetailsRedemptionHistoryRoute:
    '/customers/customer-details/:customerId/reward-history/redemption',
  customerProductPreferenceRoute: '/customers/product-preference',
  customerProductPreferenceStatusRoute: '/customers/product-preference/:status',
  customerProductAnalysisRoute: '/customers/product-analysis',
  customerProductAnalysisTendRoute: '/customers/product-analysis/trend',
  // TRANSACTIONS
  transactionRoute: '/transactions',
  pendingTransactionRoute: '/transactions/pending-transaction',
  successfulTransactionRoute: '/transactions/successful-transaction',
  failedTransactionRoute: '/transactions/failed-transaction',
  walletTransactionRoute: '/transactions/wallet',
  pendingWalletTransactionRoute: '/transactions/wallet/pending-transaction',
  successfulWalletTransactionRoute:
    '/transactions/wallet/successful-transaction',
  failedWalletTransactionRoute: '/transactions/wallet/failed-transaction',
  transactionDetailsRoute: '/transactions/transactions-details/:transactionId',
  // BILLS PAYMENT
  billsPaymentRoute: '/bills-payment',
  pendingBillsPaymentRoute: '/bills-payment/pending',
  successfulBillsPaymentRoute: '/bills-payment/successful',
  failedBillsPaymentRoute: '/bills-payment/failed',
  billsPaymentDetailsRoute:
    '/bills-payment/bills-payment-details/:billPaymentId',

  // LOANS
  loansRoute: '/loans',
  declinedLoansRoute: '/loans/declined',
  pendingLoansRoute: '/loans/pending',
  disbursedLoansRoute: '/loans/disbursed',
  awaitingApprovalLoansRoute: '/loans/awaiting-approval',
  loanDetailsRoute: '/loans/loans-details/:loanId',

  // REPAYMENT
  repaymentsRoute: '/repayments',
  dueRepaymentRoute: '/repayments/due',
  upcomingRepaymentRoute: '/repayments/upcoming',
  defaultRepaymentRoute: '/repayments/default',
  paidRepaymentRoute: '/repayments/paid',
  repaymentDetailsRoute: '/repayments/repayment-details/:repaymentId',

  // RENT COLLECTION
  rentCollectionRoute: '/rent-collection',
  rentCollectionSettledRoute: '/rent-collection/settled',
  rentCollectionAwaitingSettlement: '/rent-collection/awaiting',
  rentCollectionRefunded: '/rent-collection/refunded',
  rentCollectionDetailsRoute:
    '/rent-collection/rent-collection-details/:rentCollectionId',
  rentCollectionPendingPayment: '/rent-collection/pending',

  // Rewards
  rewardsRoute: '/rewards',
  rewardStatistics: '/rewards/statistics',
  rewardDetailsRoute: '/rewards/rewards-details/:userId',
  realtorDetailsRoute: '/rewards/realtor-details/:agentId',
  rewardrealtorsTrackingCode: '/rewards/realtors-tracking-code',
  rewardpartnersTrackingCode: '/rewards/partners-tracking-code',
  rewardPartnerCoupons: '/rewards/partner-coupons',
  partnerDetailsRoute: '/rewards/partner-details/:partnerId',

  // Settings
  settingsRoute: '/settings',
  settingsTeamMemberRoute: '/settings/user-management',
  settingsTeamMemberDetailsRoute: '/settings/user-management/:memberId',
  // GUARANTEES (MAIN)
  guaranteesRoute: '/guarantees',
  allMainGuaranteesRoute: '/guarantees/main',
  awaitingPaymentGuaranteesRoute: '/guarantees/main/awaiting-payment',
  awaitingApprovalGuaranteesRoute: '/guarantees/main/awaiting-approval',
  ongoingGuaranteesRoute: '/guarantees/main/ongoing-approval',
  paidGuaranteesRoute: '/guarantees/main/paid',
  declinedGuaranteesRoute: '/guarantees/main/declined',
  // GUARANTEES (PRE-APPROVAL)
  allPreApprovalGuaranteesRoute: '/guarantees/pre-approval',
  awaitingPaymentPreApprovalGuaranteesRoute:
    '/guarantees/pre-approval/awaiting-payment',
  approvedPreApprovalGuaranteesRoute: '/guarantees/pre-approval/approved',
  paidPreApprovalGuaranteesRoute: '/guarantees/pre-approval/paid',
  declinedPreApprovalGuaranteesRoute: '/guarantees/pre-approval/declined',
  // GUARANTEES DETAILS (MAIN/PRE-APPROVAL)
  guaranteeDetailsRoute: '/guarantees/guarantee-details/:guaranteeId',

  // HOUSING APPLICATION
  housingApplicationRoute: '/housing-applications',
  housingApplicationStatusRoute: '/housing-applications/:status',
  housingApplicationDetailsRoute: '/housing-applications/details/:id',
  housingApplicationDetailsProfileRoute:
    '/housing-applications/details/:id/profile',
  housingApplicationDetailsApplicationRoute:
    '/housing-applications/details/:id/monitoring',

  // RENT COLLECTION
  equifaxReportRoute: '/equifax-reports',
  equifaxSubmittedReportRoute: '/equifax-reports/submitted',
  notSubmittedEquifaxReportRoute: '/equifax-reports/not-submitted',

  // PASSWORD RESET
  passwordChangeRoute: '/password-reset',
  // PASSWORD RESET REQUEST
  forgotPasswordRoute: '/forgot-password',
  // NOT ALLOWED
  notAllowedRoute: '/not-allowed',
  // 404 NOT FOUND
  notFoundRoute: '*',
};
